// extracted by mini-css-extract-plugin
module.exports = {"ts-checkbox":"Signup-module--ts-checkbox--ztR3o","checkbox-label":"Signup-module--checkbox-label--3ilTL"};